export const scrollToHash = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
};
